import { Select } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useEinrichtungList } from '@/api/useEinrichtung';
import { useAppStore } from '@/store/appStore';

export function EinrichtungSwitcher() {
  const { t } = useTranslation('common');
  const traegerId = useAppStore((s) => s.activeTraegerId);
  const activeId = useAppStore((s) => s.activeEinrichtungId);
  const setEinrichtung = useAppStore((s) => s.setEinrichtung);
  const { data, isLoading } = useEinrichtungList(traegerId);

  const options = useMemo(
    () => (data ?? []).map((e) => ({ value: e.id, label: e.name })),
    [data],
  );

  return (
    <Select
      label={t('header.einrichtung')}
      placeholder={traegerId ? t('header.einrichtung') : t('state.empty')}
      data={options}
      value={activeId}
      onChange={setEinrichtung}
      disabled={!traegerId || isLoading}
      searchable
      nothingFoundMessage={t('state.empty')}
      w={220}
      aria-label={t('header.einrichtung')}
    />
  );
}
